module.exports = __webpack_public_path__ + "img/empty-orders-v2.38320194.svg";